import React, { useState } from "react";
import "./contact.scss";
import emailjs from '@emailjs/browser';
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";

export default function ContactPage() {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);

  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        () => {
          setPopupMessage('✅ Message sent successfully!');
          setIsSubmitting(false);
          e.target.reset();
        },
        () => {
          setPopupMessage('❌ Something went wrong. Please try again later.');
          setIsSubmitting(false);
        }
      );
    
    // Clears the form after sending the email
    // e.target.reset();
  };

  const closePopup = () => setPopupMessage(null);
  return (
    <>
    <Navbar />
    <div className="contact-page">
      <section className="head-office">
        <div className="details">
          <h2>Head Office Details</h2>
          <div className="item">
            <p><span>Address: </span>Daily Help United Limited<br /><br /> 25 Snowdrop Street, Liverpool, <br />Merseyside, L5 7RT</p>
          </div>
          <div className="item">
            <p><span>Phone: </span>+44 7405 797297</p>
          </div>
          <div className="item">
            <p><span>Email: </span>info@dailyhelpunited.co.uk</p>
          </div>
        </div>
      </section>

      <section className="get-in-touch">
        <h2>Get in Touch</h2>
        <p>Please complete the form below and we will get straight back to you</p>

        <form className="contact-form" onSubmit={sendEmail}>
          <div className="row">
            <input type="text" name="user_name" placeholder="Full Name" />
            <input type="email" name="user_email" placeholder="Email Address" />
          </div>

          <div className="row">
            <input type="text" name="user_phone" placeholder="Phone Number" />
            <div className="checkboxes">
              <label>
                  <input type="radio" name="care_work" value="Care Vacancies" /> Care Vacancies
                </label>
                <label>
                  <input type="radio" name="care_work" value="Care Services" /> Care Services
                </label>
            </div>
          </div>

          <textarea name="user_message" placeholder="Message" rows="6"></textarea>

          <button type="submit" className="submit-btn">Submit</button>
        </form>
      </section>
    </div>
    <Footer />

    {popupMessage && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-message">
            <p>{popupMessage}</p>
            <button onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
    </>
  );
}